import { useEffect } from 'react';
import Page from 'shared/types/Page'
import getSubMenu from 'shared/utils/getSubMenu'
import getPageByPath from 'shared/utils/getPageByPath'
import MenuIcons from 'components/AppRouter/MenuIcons'

interface useInitProps {
    setSubMenuPages: Function
    curLink: string
    setActiveClass: Function
    setIcon: Function
    curIcon?: any
    curIconActive?: any
    isActive?: boolean
    pages?: Page[] | undefined
    curPage: Page | null
}

const useInit = (props: useInitProps) => {
    
    useEffect(() => {

        if (props.curPage) {
            
            let isActive = false
            const subPages = getSubMenu({
                curPage: props.curPage,
                curLink: props.curLink,
                pages: props.pages
            })
            props.setSubMenuPages(subPages)
    
            let newActiveClass = ''
    
            // determine if parent
            if (props.curPage?.parentPath !== undefined) {
    
                const parentPage = getPageByPath(props.curPage.parentPath)

                if (props.curLink === props.curPage.parentPath ||
                    (parentPage?.parentPath !== undefined &&
                        parentPage.parentPath === props.curLink)) {
                    newActiveClass = " active parent"
                    isActive = true
                }
                
            }
    
            // determine active if not parent
            if (!newActiveClass.length && (props.curPage != null)) {
                if (props.curLink === props.curPage.path) {
                    newActiveClass = ""
                    isActive = true
                }
            }
            
            if (props.curIcon) {
                const icon = isActive ? MenuIcons[props.curIcon]['active'] : MenuIcons[props.curIcon]['inactive']
                props.setIcon(<span className="icon-cont">{icon}</span>)
            }
            props.setActiveClass(newActiveClass)
        }

    }, [props.curPage])
}

export default useInit